import variables from '../../styles/themes/theme/variables.scss';

const config = {
    siteName: 'Efsanebahis',
    licenseText: {
        en: 'Efsanebahis is owned and operated by Enigma Digital Solutions Limitada. Registration number: 3102916990, registered address: Ofident Building, Office No.3, San Jose, Costa Rica. Contact us: destek@efsanemail.com . Efsanebahis is licensed and regulated by the Government of the Autonomous Island of Anjouan, Union of Comoros, and operates under License No. ALSI-202412045-F12. Efsanebahis has passed all regulatory compliance and is legally authorized to conduct gaming operations for any and all games of chance and wagering.',
        // tr: "",
        // aa: "",
        // pt: "",
        // es: "",
        // fr: "",
        // ko: "",
        // ja: "",
    },
    themeCSSVars: variables,
    couponPrint: false,
    withGoogleAnalytics: true,
    betBuilderTermsLinks: true,
    siteConfig: {
        email: '%%site.email%%',
        appearanceRules: {
            isLiveChat: true,
            isSignUp: true,
            isMobileSupportButton: true,
            isSocialIcons: true,
            sportIcons: 'svg',
        },
        permissionRules: {
            isAboutUs: true,
            isPayments: true,
            isForgotPassword: true,
        },
    },
    verifyEmailIframeSrc: 'http://wlefsanebahis.adsrv.eacdn.com/Processing/Pixels/Registration.ashx?PlayerID={{customerId}}&mid=23',
    contactUs: {
        showSupportBlock: true,
        en: {
            contactAnswersRow: 'You can reach to answers of your questions from our Frequently Asked Questions, Help and Rules pages.',
            contactEmailRow: 'You can write us a mail if you could not find an answer for your question in our pages.',
            liveSupportBlock: 'Our live support will be available 7/24.',
            emailBlock: 'You can reach us by mail if you want to know any other information about us.',
            notForgetRow: 'Do not forget that our live support is working carefully on your questions and complains. Please do not send any messages twice if its about the same question.',
        },
        tr: {
            contactAnswersRow: 'Yardım, Kurallar ve Sıkça Sorulan Sorular sayfalarımızda merak ettiğiniz konular ile ilgili bilgilere ulaşabilirsiniz.',
            contactEmailRow: '',
            liveSupportBlock: 'Canlı yardım bölümümüz 7/24 hizmet vermektedir.',
            emailBlock: 'Hizmetlerimiz ile ilgili olarak daha ayrıntılı bilgi almak isterseniz, bizlere E-posta yolu ile ulaşabilirsiniz.',
            notForgetRow:
                'Müşteri hizmetlerimizin, şikayet ve taleplerinizi olabildiğince çabuk ve dikkatli bir şekilde ele aldığını unutmayınız. Aynı konu ile ilgili birden fazla talep göndermeyiniz.',
        },
    },
    aboutUs: {
        en: [
            'EfsaneBahis is one of the fastest growing betting website with their variety of sports, amount of the bets and live bets, championship bets, casino and amount of the live casino games.',
            'Your information and processes are safe with their continuously renewed highly standard security systems.',
            'You can reach us whenever you want with mobile or live support.',
        ],
        tr: [
            'EfsaneBahis, uluslararası oyun alanında yıllardır hizmet vermekte olan ekibiyle; spor bahislerindeki ve canlı casino oyunlarındaki çeşitliliği ile öne çıkan bir bahis firmasıdır.',
            "EfsaneBahis 2004 yılından beri işinin ehli yönetim kadrosuyla 2017'nin ikinci çeyreğinde Türkiye pazarında hizmete açılmış bulunmaktadır.",
            'Tamamen oyuncu dostu olarak tabir edilebilecek arayüzü ve hızlı mobil servisi ile hizmet vermektedir.',
            'EfsaneBahis güçlü finans gücü ve çeşitli ödeme çeşitleriyle oyuncularımıza bir çok alternatif vermekle birlikte yatırım ve çekim işlemlerini de kolaylaştırmaktadır.',
            'Sizlerin tavsiyeleri ile güncellenen, oyuncunun isteği doğrultusunda yenilenen ve kaliteli Teknik desteği ile bilgilerinizin güvenliğini sağlayan bir kuruluştur.',
            '7/24 Canlı Destek hattımızdan bilgi alabilir, isteğiniz doğrultusunda telefon ile de bağlantı kurabilirsiniz. Bizlere kolayca ulaşabilmeniz bizim için çok önemlidir.',
        ],
    },

    headerMobileTabs: [
        {
            name: 'Sport',
            icon: 'doruk-sports-menu-01',
            as: 'NavLink',
            elementAttributes: {
                to: '/sport/1',
            },
        },
        {
            name: 'Live',
            icon: 'doruk-live-match-01',
            as: 'NavLink',
            elementAttributes: {
                to: '/sport/live',
            },
        },
        // {
        //     name: 'RACEBOOK_MENU_NAME',
        //     icon: 'doruk-horse-racing',
        //     as: 'NavLink',
        //     elementAttributes: {
        //         to: '/racebook',
        //     },
        // },
        {
            name: 'Slots',
            icon: 'doruk-slots-01',
            as: 'NavLink',
            elementAttributes: {
                to: '/slots',
            },
        },
        {
            name: 'Live Slot',
            icon: 'doruk-live-casino',
            as: 'NavLink',
            elementAttributes: {
                to: '/live-slots',
            },
            isNew: true,
        },
        {
            name: 'Casino',
            icon: 'doruk-casino-01',
            as: 'NavLink',
            elementAttributes: {
                to: '/casino',
            },
        },
        {
            name: 'Lobby',
            icon: 'doruk-games-lobby',
            as: 'NavLink',
            elementAttributes: {
                to: '/lobby',
            },
        },
        {
            name: 'Virtual Sports',
            icon: 'doruk-virtual-games-01',
            gameId: 'virtual',
            elementAttributes: {
                to: '?launch=virtual',
                onClick: true,
            },
            elementAttributesMobileUserAgent: {
                href: '/api/virtual/play?id=vfb',
                rel: 'noopener noreferrer',
                target: '_blank',
                onClick: true,
            },
        },
        {
            name: 'Crash Games',
            icon: 'doruk-aviator-01',
            disabled: '%%site.crashGames.isMenuItemDisabled{boolean}%%',
            subItems: '%%site.crashGames.games{array}%%',
        },
        {
            name: 'Promo',
            icon: 'doruk-bonuses-01',
            as: 'NavLink',
            elementAttributes: {
                to: '/promo',
            },
        },
        // {
        //     name: 'EFSANETV',
        //     icon: 'llg-tv',
        //     elementAttributes: {
        //         href: 'https://t2m.io/efsanetv',
        //         target: '_blank',
        //         rel: 'noopener noreferrer',
        //     },
        // },
    ],

    navigationDrawerMenu: [
        {
            label: 'Sport',
            icon: 'doruk-sports-menu-01',
            elementAttributes: {
                to: '/sport/1',
            },
        },
        {
            label: 'Live',
            icon: 'doruk-live-match-01',
            elementAttributes: {
                to: '/sport/live',
            },
        },
        // {
        //     label: 'RACEBOOK_MENU_NAME',
        //     icon: 'doruk-horse-racing',
        //     elementAttributes: {
        //         to: '/racebook',
        //     },
        // },
        {
            label: 'Slots',
            icon: 'doruk-slots-01',
            elementAttributes: {
                to: '/slots',
            },
        },
        {
            name: 'Live Slot',
            icon: 'doruk-live-casino',
            as: 'NavLink',
            elementAttributes: {
                to: '/live-slots',
            },
            isNew: true,
        },
        {
            label: 'Casino',
            icon: 'doruk-casino-01',
            elementAttributes: {
                to: '/casino',
            },
        },
        {
            name: 'Lobby',
            icon: 'doruk-games-lobby',
            as: 'NavLink',
            elementAttributes: {
                to: '/lobby',
            },
        },
        {
            label: 'Virtual Sports',
            icon: 'doruk-virtual-games-01',
            gameId: 'virtual',
            elementAttributes: {
                to: '?launch=virtual',
                onClick: true,
            },
            elementAttributesMobileUserAgent: {
                href: '/api/virtual/play?id=vfb',
                rel: 'noopener noreferrer',
                target: '_blank',
                onClick: true,
            },
        },
        {
            name: 'Crash Games',
            icon: 'doruk-aviator-01',
            disabled: '%%site.crashGames.isMenuItemDisabled{boolean}%%',
            subItems: '%%site.crashGames.games{array}%%',
        },
        {
            label: 'Promotions',
            icon: 'doruk-bonuses-01',
            elementAttributes: {
                to: '/promo',
            },
        },
        // {
        //     name: 'EFSANETV',
        //     icon: 'llg-tv',
        //     elementAttributes: {
        //         href: 'https://t2m.io/efsanetv',
        //         target: '_blank',
        //         rel: 'noopener noreferrer',
        //     },
        // },
    ],

    footerContentMenu: [
        {
            title: '%%site.siteName%%',
            skipTranslation: true,
            links: [
                {
                    name: 'About Us',
                    disabled: false,
                    elementAttributes: {
                        to: '/aboutus',
                    },
                },
                {
                    id: 'frequently_asked_questions',
                    name: 'F.A.Q.',
                    needLang: true,
                },
                {
                    id: 'general_rules',
                    name: 'Rules',
                    needLang: true,
                },
                {
                    name: 'Contact Us',
                    elementAttributes: {
                        to: '/contact-us',
                    },
                },
            ],
        },
        {
            title: 'Bettings',
            links: [
                {
                    name: 'Sport Betting',
                    elementAttributes: {
                        to: '/sport/1',
                    },
                },
                {
                    name: 'Live Betting',
                    elementAttributes: {
                        to: '/sport/live',
                    },
                },
                {
                    name: 'Virtual Sports',
                    elementAttributes: {
                        to: '?launch=virtual',
                    },
                },
            ],
        },
        {
            title: 'Casino',
            links: [
                {
                    name: 'Live Casino',
                    elementAttributes: {
                        to: '/casino',
                    },
                },
                {
                    name: 'Live Bingo',
                    elementAttributes: {
                        to: '/live-games',
                        onClick: true,
                    },
                },
                {
                    name: 'Slots',
                    elementAttributes: {
                        to: '/slots',
                    },
                },
            ],
        },
        {
            title: 'Shortcuts',
            links: [
                {
                    name: 'Bonus',
                    elementAttributes: {
                        to: '/promo',
                    },
                },
            ],
        },
    ],

    footerMobileMenu: [
        {
            label: 'Sign in',
            icon: 'doruk-my-accont-01',
            isLogged: false,
            drawer: {
                key: 'login-form-drawer',
                side: 'left',
            },
        },
        {
            label: 'Sign up',
            icon: 'doruk-login-01',
            isLogged: false,
            accent: true,
            drawer: {
                key: 'signup-form-drawer',
                side: 'left',
            },
        },
        {
            label: 'Money',
            icon: 'doruk-money-01',
            isLogged: true,
            as: 'NavLink',
            elementAttributes: {
                to: '/account/withdraws',
            },
        },
        {
            label: 'Deposit Money',
            icon: 'doruk-deposit-01',
            isLogged: true,
            hideForBlocked: true,
            as: 'NavLink',
            elementAttributes: {
                to: '/account/deposit',
            },
        },
        {
            label: 'Support',
            icon: 'doruk-support-01',
            drawer: {
                key: 'support-drawer',
                side: 'right',
            },
        },
        {
            label: 'My account',
            icon: 'doruk-my-accont-01',
            isLogged: true,
            drawer: {
                key: 'my-account-menu-drawer',
                side: 'left',
            },
        },
    ],

    footerDesktop: {
        leftPart: [
            {
                id: 'popular-games',
                label: 'Popular Games',
                icon: 'llg-empire',
                elementAttributes: {
                    to: '/casino',
                },
            },
            // {
            //     label: 'Fortune wheel',
            //     icon: 'llg-empire',
            //     elementAttributes: {
            //         href: 'https://www.efsanecarkifelek.com',
            //         target: '_blank',
            //         rel: 'noopener noreferrer',
            //     },
            // },
        ],
        centerPart: [
            {
                elementAttributes: {
                    to: '/',
                },
            },
        ],
        rightPart: [
            {
                id: 'frequently_asked_questions',
                label: 'Help',
                icon: 'doruk-questions',
                needLang: true,
            },
            {
                id: 'liveChat',
                label: 'Live Support',
                icon: 'doruk-live-support-01',
            },
            // {
            //     label: 'Sizi Arayalım',
            //     icon: 'doruk-live-support-01',
            //     elementAttributes: {
            //         href: 'http://efsanedestek.com/destek.html',
            //         target: '_blank',
            //         rel: 'noopener noreferrer',
            //     },
            // },
        ],
    },

    loginDrawerMenu: [
        {
            label: 'Help',
            icon: 'doruk-questions',
        },
        {
            label: 'Live Support',
            icon: 'doruk-live-support-01',
        },
    ],

    headerDesktopTabs: [
        {
            name: 'Sport',
            icon: 'doruk-sports-menu-01',
            as: 'NavLink',
            elementAttributes: {
                to: '/sport/1',
            },
            key: 'prematchPage',
        },
        {
            name: 'Live',
            icon: 'doruk-live-match-01',
            as: 'NavLink',
            elementAttributes: {
                to: '/sport/live',
            },
        },
        // {
        //     name: 'RACEBOOK_MENU_NAME',
        //     icon: 'doruk-horse-racing',
        //     as: 'NavLink',
        //     elementAttributes: {
        //         to: '/racebook',
        //     },
        // },
        {
            name: 'Slots',
            icon: 'doruk-slots-01',
            as: 'NavLink',
            elementAttributes: {
                to: '/slots',
            },
        },
        {
            name: 'Live Slot',
            icon: 'doruk-live-casino',
            as: 'NavLink',
            elementAttributes: {
                to: '/live-slots',
            },
            isNew: true,
        },
        {
            name: 'Casino',
            icon: 'doruk-casino-01',
            as: 'NavLink',
            elementAttributes: {
                to: '/casino',
            },
        },
        {
            name: 'Lobby',
            icon: 'doruk-games-lobby',
            as: 'NavLink',
            elementAttributes: {
                to: '/lobby',
            },
        },
        {
            name: 'Virtual Sports',
            icon: 'doruk-virtual-games-01',
            elementAttributes: {
                to: '?launch=virtual',
            },
        },
        {
            name: 'Crash Games',
            icon: 'doruk-aviator-01',
            disabled: '%%site.crashGames.isMenuItemDisabled{boolean}%%',
            subItems: '%%site.crashGames.games{array}%%',
        },
        {
            name: 'Promotions',
            icon: 'doruk-bonuses-01',
            as: 'NavLink',
            elementAttributes: {
                to: '/promo',
            },
        },
        // {
        //     name: 'EFSANETV',
        //     icon: 'llg-tv',
        //     elementAttributes: {
        //         href: 'https://t2m.io/efsanetv',
        //         target: '_blank',
        //         rel: 'noopener noreferrer',
        //     },
        // },
    ],

    slotsCasinoMenu: [
        {
            name: 'Featured',
            type: 'featured',
            as: 'NavLink',
            elementAttributes: {
                to: '/featured',
            },
            icon: 'doruk-favorite-game',
        },
        {
            name: 'New',
            type: 'new',
            as: 'NavLink',
            elementAttributes: {
                to: '/new',
            },
            icon: 'doruk-new-game',
        },
        {
            name: 'Popular',
            type: 'popular',
            as: 'NavLink',
            elementAttributes: {
                to: '/popular',
            },
            icon: 'doruk-filter-popular-01',
        },
        {
            name: 'Game Type',
            type: 'gameType',
            icon: 'doruk-filter-game-type-01',
            submenu: 'GameType',
        },
        {
            name: 'Provider',
            type: 'provider',
            icon: 'doruk-filter-provider-01',
            submenu: 'Provider',
        },
        {
            name: 'Jackpots',
            type: 'jackpots',
            icon: 'doruk-icon-jackpot',
            as: 'NavLink',
            elementAttributes: {
                to: '/jackpots',
            },
        },
        {
            name: 'SLOT_BATTLE',
            icon: 'doruk-slot-battles',
            as: 'NavLink',
            disabled: '%%site.slotBattlesConfig.slotBattlesDisabled{boolean}%%',
            elementAttributes: {
                to: '/slots-battles',
            },
        },
        {
            name: 'Favorite',
            type: 'favorite',
            as: 'NavLink',
            elementAttributes: {
                to: '/favorite',
            },
            icon: 'doruk-favorites',
        },
        {
            name: 'Recently played',
            type: 'recently-played',
            as: 'NavLink',
            elementAttributes: {
                to: '/recently-played',
            },
            icon: 'doruk-recently-played',
        },
    ],

    slotsCasinoMobileMenu: [
        {
            name: 'Featured',
            type: 'featured',
            as: 'NavLink',
            elementAttributes: {
                to: '/featured',
            },
            icon: 'doruk-favorite-game',
        },
        {
            name: 'New',
            type: 'new',
            as: 'NavLink',
            elementAttributes: {
                to: '/new',
            },
            icon: 'doruk-new-game',
        },
        {
            name: 'Popular',
            type: 'popular',
            as: 'NavLink',
            elementAttributes: {
                to: '/popular',
            },
            icon: 'doruk-filter-popular-01',
        },
        {
            name: 'Sort by',
            type: 'sortBy',
            position: {
                upper: true,
            },
            icon: 'doruk-filter-sort-by-01',
            submenu: [
                {
                    name: 'A - Z',
                    sort: [
                        { selector: 'GameName', desc: false },
                        { selector: 'SortOrder', desc: false },
                    ],
                    icon: 'llg-long-arrow-down',
                },
                {
                    name: 'Z - A',
                    sort: [
                        { selector: 'GameName', desc: true },
                        { selector: 'SortOrder', desc: false },
                    ],
                    icon: 'llg-long-arrow-up',
                },
                {
                    name: 'Oldest',
                    sort: [
                        { selector: 'IsGameNew', desc: false },
                        { selector: 'Created', desc: false },
                        { selector: 'SortOrder', desc: false },
                        { selector: 'GameName', desc: false },
                    ],
                    icon: 'llg-long-arrow-down',
                },
                {
                    name: 'Newest',
                    sort: [
                        { selector: 'IsGameNew', desc: true },
                        { selector: 'Created', desc: true },
                        { selector: 'SortOrder', desc: false },
                        { selector: 'GameName', desc: false },
                    ],
                    icon: 'llg-long-arrow-up',
                },
                {
                    name: 'Popular',
                    sort: [
                        { selector: 'LaunchCnt', desc: true },
                        { selector: 'SortOrder', desc: false },
                        { selector: 'GameName', desc: false },
                    ],
                    icon: 'doruk-sort-by-popular',
                },
            ],
        },
        {
            name: 'Game Type',
            type: 'gameType',
            icon: 'doruk-filter-game-type-01',
            submenu: 'GameType',
        },
        {
            name: 'Provider',
            type: 'provider',
            icon: 'doruk-filter-provider-01',
            submenu: 'Provider',
        },
        {
            name: 'Jackpots',
            type: 'jackpots',
            icon: 'doruk-icon-jackpot',
            as: 'NavLink',
            elementAttributes: {
                to: '/jackpots',
            },
        },
        {
            name: 'SLOT_BATTLE',
            icon: 'doruk-slot-battles',
            type: 'slots-battles',
            as: 'NavLink',
            disabled: '%%site.slotBattlesConfig.slotBattlesDisabled{boolean}%%',
            elementAttributes: {
                to: '/slots-battles',
            },
        },
        {
            name: 'Favorite',
            type: 'favorite',
            as: 'NavLink',
            elementAttributes: {
                to: '/favorite',
            },
            icon: 'doruk-favorites',
        },
        {
            name: 'Recently played',
            type: 'recently-played',
            as: 'NavLink',
            elementAttributes: {
                to: '/recently-played',
            },
            icon: 'doruk-recently-played',
        },
        {
            name: '{{PLAY_MODE}}',
            type: 'play-mode',
            icon: 'llg-money',
        },
    ],

    slotsCasinoUpperMenu: [
        {
            type: 'playMode',
            position: {
                mobileOnly: true,
                upper: true,
                start: true,
            },
            icon: 'llg-poker-chip',
            submenu: [
                {
                    name: 'REAL_PLAY_BTN',
                    demo: 0,
                    icon: 'llg-money',
                },
                {
                    name: 'FUN_PLAY_BTN',
                    demo: 1,
                    icon: 'llg-star-filled',
                },
            ],
        },
        {
            name: 'Sort by',
            type: 'sortBy',
            position: {
                upper: true,
            },
            icon: 'doruk-filter-sort-by-01',
            submenu: [
                {
                    name: 'A - Z',
                    sort: [
                        { selector: 'GameName', desc: false },
                        { selector: 'SortOrder', desc: false },
                    ],
                    icon: 'llg-long-arrow-down',
                },
                {
                    name: 'Z - A',
                    sort: [
                        { selector: 'GameName', desc: true },
                        { selector: 'SortOrder', desc: false },
                    ],
                    icon: 'llg-long-arrow-up',
                },
                {
                    name: 'Oldest',
                    sort: [
                        { selector: 'IsGameNew', desc: false },
                        { selector: 'Created', desc: false },
                        { selector: 'SortOrder', desc: false },
                        { selector: 'GameName', desc: false },
                    ],
                    icon: 'llg-long-arrow-down',
                },
                {
                    name: 'Newest',
                    sort: [
                        { selector: 'IsGameNew', desc: true },
                        { selector: 'Created', desc: true },
                        { selector: 'SortOrder', desc: false },
                        { selector: 'GameName', desc: false },
                    ],
                    icon: 'llg-long-arrow-up',
                },
                {
                    name: 'Popular',
                    sort: [
                        { selector: 'LaunchCnt', desc: true },
                        { selector: 'SortOrder', desc: false },
                        { selector: 'GameName', desc: false },
                    ],
                    icon: 'doruk-sort-by-popular',
                },
            ],
        },
    ],

    slotsCasinoMobileUpperMenu: [
        {
            type: 'playMode',
            position: {
                mobileOnly: true,
                upper: true,
                start: true,
            },
            icon: 'llg-poker-chip',
            submenu: [
                {
                    name: 'REAL_PLAY_BTN',
                    demo: 0,
                    icon: 'llg-money',
                },
                {
                    name: 'FUN_PLAY_BTN',
                    demo: 1,
                    icon: 'llg-star-filled',
                },
            ],
        },
        {
            type: 'filters',
            name: 'Filters',
            position: {
                mobileOnly: true,
                upper: true,
            },
            icon: 'doruk-filters',
            submenu: 'slotsCasinoMobileMenu',
        },
    ],

    footerLicenceIcons: [
        {
            icon: 'll-license-icons--license',
            sealId: 'c217c525-aa55-448d-aef2-0f542853d93f',
        },
        {
            rules: true,
            icon: 'll-license-icons--18',
            customClasses: 'luckyland-link',
            needLang: true,
        },
        {
            icon: 'll-license-icons--circle',
            elementAttributes: {
                to: '/contact-us',
            },
        },
        // {
        //     modalLink: 'https://www.luckylandgaming.com/',
        //     icon: 'll-license-icons--logo',
        // },
    ],

    mobileLicenceIcons: [
        {
            rules: true,
            icon: 'll-license-icons--18',
            needLang: true,
        },
        {
            icon: 'll-license-icons--license',
            sealId: 'c217c525-aa55-448d-aef2-0f542853d93f',
        },
    ],

    // mobileSupportMenuAdditionalBtns: [
    //     {
    //         label: 'Fortune wheel',
    //         icon: 'llg-empire',
    //         elementAttributes: {
    //             href: 'https://www.efsanecarkifelek.com',
    //             target: '_blank',
    //             rel: 'noopener noreferrer',
    //         },
    //     },
    //     {
    //         label: 'Sizi Arayalım',
    //         icon: 'doruk-live-support-01',
    //         elementAttributes: {
    //             href: 'http://efsanedestek.com/destek.html',
    //             target: '_blank',
    //             rel: 'noopener noreferrer',
    //         },
    //     },
    // ],

    /*
     * name - string,
     * disabled - boolean  (hide button),
     * id - string
     * iframe - string (url for iframe)
     * icon - string
     * to - string (url for external link)
     */
    mobileSupportMenu: [
        {
            name: 'Live support',
            id: 'liveChat',
            disabled: false,
            icon: 'doruk-live-support-01',
        },
        {
            id: 'general_rules',
            name: 'Rules',
            icon: 'doruk-rules-01',
            needLang: true,
        },
        {
            name: 'About Us',
            icon: 'doruk-about-us-01',
            disabled: false,
            elementAttributes: {
                to: '/aboutus',
            },
        },
        {
            name: 'Contact Us',
            icon: 'doruk-support-01',
            disabled: false,
            elementAttributes: {
                to: '/contact-us',
            },
        },
        {
            id: 'frequently_asked_questions',
            name: 'Frequently asked questions',
            icon: 'doruk-questions',
            needLang: true,
        },
    ],

    myAccountDesktopMenu: [
        {
            name: 'my-info',
            icon: 'ma-my-information-01',
            link: 'my-info',
            visibleForBlockedUser: true,
        },
        {
            name: 'affiliates',
            icon: 'ma-my-information-01',
            link: 'affiliates',
            disabled: '%%user.isAffiliateBlocked{boolean}%%',
        },
        {
            name: 'deposits',
            icon: 'ma-deposit-01',
            link: 'deposit',
        },
        {
            name: 'withdraws',
            icon: 'ma-withdraw-01',
            link: 'withdraws',
        },
        {
            name: 'withdraw-status',
            icon: 'ma-withdraw-status-01',
            link: 'withdraw-status',
        },
        {
            name: 'betting-history',
            icon: 'ma-betting-history-01',
            link: 'betting-history',
            visibleForBlockedUser: true,
        },
        {
            name: 'account-history',
            icon: 'ma-account-history-01',
            link: 'account-history',
            visibleForBlockedUser: true,
        },
        {
            name: 'casino-report',
            icon: 'ma-casino-report-01',
            link: 'casino-report',
            visibleForBlockedUser: true,
        },
        {
            name: 'limits',
            icon: 'ma-my-limits-01',
            link: 'limits',
            visibleForBlockedUser: true,
        },
        {
            name: 'google-auth',
            icon: 'ma-google-authenticator-01',
            link: 'google-auth',
            visibleForBlockedUser: true,
        },
        {
            name: 'messages',
            icon: 'ma-mssages-01',
            link: 'messages',
            visibleForBlockedUser: true,
        },
    ],
    /*
     * name - string,
     * storeLink - string (show value from store),
     * disabled - boolean  (hide button),
     * path - string
     * visibleForBlockedUser - boolean,
     * hideForDesktop - boolean
     * image - string (svg name for the menu item in Desktop menu)
     * storeCurrencyLink - boolean (show data with two digits after comma)
     */
    myAccountMenu: [
        {
            name: 'my-info',
            elementAttributes: {
                to: '/account/my-info',
            },
            icon: 'ma-my-information-01',
            visibleForBlockedUser: true,
        },
        {
            name: 'affiliates',
            icon: 'ma-my-limits-01',
            elementAttributes: {
                to: '/account/affiliates',
            },
            disabled: '%%user.isAffiliateBlocked{boolean}%%',
        },
        {
            name: 'deposits',
            elementAttributes: {
                to: '/account/deposit',
            },
            icon: 'ma-deposit-01',
        },
        {
            name: 'withdraws',
            elementAttributes: {
                to: '/account/withdraws',
            },
            icon: 'ma-withdraw-01',
        },
        {
            name: 'withdraw-status',
            elementAttributes: {
                to: '/account/withdraw-status',
            },
            icon: 'ma-withdraw-status-01',
        },
        {
            name: 'account-history',
            elementAttributes: {
                to: '/account/account-history',
            },
            icon: 'ma-betting-history-01',
            visibleForBlockedUser: true,
        },
        {
            name: 'betting-history',
            drawer: {
                key: 'my-bets-drawer',
                side: 'right',
            },
            icon: 'ma-account-history-01',
            visibleForBlockedUser: true,
        },
        {
            name: 'casino-report',
            elementAttributes: {
                to: '/account/casino-report',
            },
            icon: 'ma-casino-report-01',
            visibleForBlockedUser: true,
        },
        {
            name: 'limits',
            elementAttributes: {
                to: '/account/limits',
            },
            icon: 'ma-my-limits-01',
            visibleForBlockedUser: true,
        },
        {
            name: 'google-auth',
            elementAttributes: {
                to: '/account/google-auth',
            },
            icon: 'ma-google-authenticator-01',
            visibleForBlockedUser: false,
        },
        {
            name: 'messages',
            elementAttributes: { to: '/account/messages' },
            icon: 'ma-mssages-01',
            storeLink: 'messageCount',
            visibleForBlockedUser: true,
            hideForDesktop: true,
        },
    ],

    // * disabled - boolean  (hide icon),

    socialIcons: [
        {
            elementAttributes: {
                href: 'https://mail.google.com/',
                target: '_blank',
                rel: 'noopener noreferrer',
            },
            icon: 'llg-envelope-o',
        },
        {
            elementAttributes: {
                href: 'https://www.facebook.com/',
                target: '_blank',
                rel: 'noopener noreferrer',
            },
            icon: 'llg-facebook',
        },
        {
            elementAttributes: {
                href: 'https://web.telegram.org/',
                target: '_blank',
                rel: 'noopener noreferrer',
            },
            icon: 'llg-paper-plane',
        },
        {
            elementAttributes: {
                href: 'https://www.youtube.com/',
                target: '_blank',
                rel: 'noopener noreferrer',
            },
            icon: 'llg-youtube',
        },
    ],

    /**** ~~ MY ACCOUNT  ****/
    payments: {
        deposit: {
            mobileTitle: {
                en: 'Deposit options',
                // tr: '',
                // aa: '',
                // pt: '',
                // es: '',
                // fr: '',
                // ko: '',
                // ja: '',
            },
            desktopTitle: {
                en: 'Deposit options',
                // tr: '',
                // aa: '',
                // pt: '',
                // es: '',
                // fr: '',
                // ko: '',
                // ja: '',
            },
            noDataMessage: {
                en: 'There is no available deposit methods for your account.',
                // tr: '',
                // aa: '',
                // pt: '',
                // es: '',
                // fr: '',
                // ko: '',
                // ja: '',
            },
            name: 'deposits',
            getDataFunctionName: 'getDeposits',
        },
        withdraws: {
            mobileTitle: {
                en: 'Withdraw options',
                // tr: '',
                // aa: '',
                // pt: '',
                // es: '',
                // fr: '',
                // ko: '',
                // ja: '',
            },
            desktopTitle: {
                en: 'Withdraw options',
                // tr: '',
                // aa: '',
                // pt: '',
                // es: '',
                // fr: '',
                // ko: '',
                // ja: '',
            },
            noDataMessage: {
                en: 'There is no available withdraw methods for your account.',
                // tr: '',
                // aa: '',
                // pt: '',
                // es: '',
                // fr: '',
                // ko: '',
                // ja: '',
            },
            name: 'withdraws',
            getDataFunctionName: 'getWithdraws',
        },
    },

    accountReport: {
        sports: {
            desktopTitle: 'Sports bets',
            mobileTitle: 'Sports bets',
            isLabelsCapitalized: true,
            items: [
                {
                    label: 'Stake total',
                    value: '%%user.accountReport.sports.stake{number}%%',
                },
                {
                    label: 'Paid total',
                    value: '%%user.accountReport.sports.paid{number}%%',
                },
                { label: 'Net', value: '%%user.accountReport.sports.net{number}%%' },
            ],
        },
        casino: {
            desktopTitle: 'Casino',
            mobileTitle: 'Casino',
            items: '%%user.accountReport.casinoReports{array}%%',
        },
        bonus: {
            desktopTitle: 'Bonus',
            mobileTitle: 'Bonus/discount',
            isLabelsCapitalized: true,
            items: [
                { label: 'Bonus', value: '%%user.accountReport.bonus.bonus{number}%%' },
                {
                    label: 'Commission',
                    value: '%%user.accountReport.bonus.commission{number}%%',
                },
                { label: 'Net', value: '%%user.accountReport.bonus.net{number}%%' },
            ],
        },
    },

    // scripts: { //Retrobet scripts example // нужно только для Ретро и другихсайтов, где есть сторонние скрипты заказчика
    //     signupScript: "<script>window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : (window._adftrack ? [window._adftrack] : []);" +
    //                     "window._adftrack.push({" +
    //                     "pm: 1923849," +
    //                     "divider: encodeURIComponent('|')," +
    //                     "pagename: encodeURIComponent('Retrobet_Registeration')" +
    //                     "});" +
    //                     "(function () { var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://track.adform.net/serving/scripts/trackpoint/async/'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); })();" +
    //                     "</script>",
    //     headerScript: "<script>window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : (window._adftrack ? [window._adftrack] : []);" +
    //                     "window._adftrack.push({" +
    //                     "pm: 1923849," +
    //                     "divider: encodeURIComponent('|')," +
    //                     "pagename: encodeURIComponent('Retrobet_Remarketing')" +
    //                     "});" +
    //                     "(function () { var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://track.adform.net/serving/scripts/trackpoint/async/'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); })();" +
    //                     "</script>",
    // },
};

export default config;
